// modules
import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import OptionChain from 'modules/OptionChain';
import Format from 'modules/Format';
import LocaleService from 'modules/Localization';
// store
import { useStore } from 'modules/Stores';
// components
import { LoadingBlock, View } from '@upstox/upstox-ui';
// styles
import * as css from '../../styles';

const PcrCell: React.FC = () => {
  const { symbol, selectedExpiry, loading } = useStore('OptionChainStore');
  const [pcrData, setPcrData] = useState<number | null>(null);
  const fetchPcrData = useCallback(
    async (scripSymbol: string, expiry: number) => {
      const response = await OptionChain.getOIPCROrMaxPainData(
        'pcr',
        scripSymbol,
        0,
        Format.getDateFromEpoch(expiry),
      ) as OiPCRDataResponseType;
      if (response) {
        setPcrData(response?.pcr);
      }
    },
    [],
  );

  useEffect(() => {
    if (symbol && selectedExpiry) {
      fetchPcrData(symbol, selectedExpiry);
    }
  }, [fetchPcrData, symbol, selectedExpiry]);

  return (
    <View flexDirection="column">
      <View css={css.dataHeading}>{LocaleService.translate('PCR')}</View>
      {loading ? (
        <LoadingBlock height={14} width={40} />
      ) : (
        <View css={css.dataValue}>{pcrData || '--'}</View>
      )}
    </View>
  );
};

export default observer(PcrCell);
